import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { userCheckMobileScreen } from 'helpers/tools'
import Image from 'components/atoms/Image'
import HalfBanner from 'components/molecules/HalfBanner'
import { get } from 'lodash'

import './HalfBannersMosaic.scss'

function HalfBannersMosaic(props) {
  const isMobile = userCheckMobileScreen()
  const { data } = props
  const imageSrc = isMobile ? get(data, 'media.entity.images.medium.url') : get(data, 'media.entity.images.wide.url')
  const id = get(data, 'id')
  const halfBanners = get(data, 'items')
  const themeClasses = get(data, 'theme.entity.classes')

  useEffect(() => {
    if (!isMobile) {
      const halfBannerElement = document.querySelectorAll('.half-banners-mosaic__item')
      if (halfBannerElement) {
        // get half banners height and margin to get the height of the whole element
        const halfBannersMosaicHeight = [...halfBannerElement]
          .map((el) => {
            const { height } = window.getComputedStyle(el)
            const marginBottom = window.getComputedStyle(el)['margin-bottom']
            return parseInt(height) + parseInt(marginBottom)
          })
          .reduce((acc, el) => acc + el)

        // apply total height to image
        const imageContainer = document.querySelector('.half-banners-mosaic__img-container')
        if (imageContainer) imageContainer.style.height = `${halfBannersMosaicHeight}px`
      }
    }
  }, [])

  return (
    <Container id={id} fluid="fluid" className={`half-banners-mosaic section-spacing ${themeClasses}`}>
      <Container>
        <Row>
          <Col xs={12} md={6} className="half-banners-mosaic__img-container">
            <Image src={imageSrc} alt={get(data, 'media.entity.images.alt')} />
          </Col>

          <Col xs={12} md={6} className="half-banners-mosaic__item-container">
            {Array.isArray(halfBanners) &&
              halfBanners.map(({ entity }, index) => (
                <HalfBanner
                  className="half-banners-mosaic__item"
                  buttons={get(entity, 'buttons').map(({ entity }) => ({
                    id: get(entity, 'link.uuid'),
                    icon: get(entity, 'linkType.entity.token'),
                    text: get(entity, 'link.title'),
                    url: get(entity, 'link.url.path'),
                  }))}
                  description={get(entity, 'description.value')}
                  icon={get(entity, 'icon.entity.media.entity.fieldMediaFile.entity.url')}
                  imageBackground={
                    isMobile
                      ? get(entity, 'imageBackground.entity.images.medium.url')
                      : get(entity, 'imageBackground.entity.images.wide.url')
                  }
                  orientation="half-banner-row"
                  title={get(entity, 'title')}
                  theme={get(entity, 'theme.entity.classes')}
                  key={get(entity, 'uuid', index)}
                />
              ))}
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default HalfBannersMosaic
